module.exports = __webpack_public_path__ + "static/media/logo.a7ce87a3.png";